import { Provider } from "@redotech/redo-order-common/provider";
import {
  shopifyAdminOrderUrl,
  shopifyStoreName,
} from "@redotech/redo-shopify-common/admin-link-utils";
import { assertNever } from "@redotech/util/type";

export function buildExternalOrderLink(
  provider: Provider,
  externalOrderId: string,
  orderTeamUrl?: string,
): string | undefined {
  switch (provider) {
    case Provider.SHOPIFY:
      if (orderTeamUrl) {
        return shopifyAdminOrderUrl(
          shopifyStoreName(orderTeamUrl),
          externalOrderId.split("/").pop() ?? "",
        ).toString();
      }
      break;
    case Provider.EBAY:
      return `https://www.ebay.com/mesh/ord/details?orderid=${externalOrderId}`;

    case Provider.COMMENTSOLD: {
      const commentsoldOrderId = externalOrderId.replace("cs:", "");
      return `https://commentsold.com/admin/orders?order=${commentsoldOrderId}`;
    }
    case Provider.TIKTOK:
      return `https://seller-us.tiktok.com/order/detail?order_no=${externalOrderId}`;
    case Provider.FAIRE:
      return `https://www.faire.com/brand-portal/orders/${externalOrderId}`;
    case Provider.BIGCOMMERCE: {
      const match = /^([a-z0-9]+)\/order\/(\d+)$/.exec(externalOrderId);
      return match
        ? `https://store-${match[1]}.mybigcommerce.com/manage/orders/${match[2]}`
        : undefined;
    }
    case Provider.AMAZON: {
      // `amazon-{marketplaceId}-{orderId}`, and the order id has dashes too.
      // Order lookup also accepts the bare order id, so only strip a prefix
      // that's actually there.
      const amazonOrderId = externalOrderId.startsWith("amazon-")
        ? externalOrderId.split("-").slice(2).join("-")
        : externalOrderId;
      return amazonOrderId
        ? `https://sellercentral.amazon.com/orders-v3/order/${amazonOrderId}`
        : undefined;
    }
    case Provider.WALMART:
    case Provider.APPAREL_MAGIC:
    case Provider.REDO_MARKETPLACE:
    case Provider.REDO:
    case Provider.SFOM:
    case Provider.AIMS360:
    case Provider.CIN7_OMNI:
    case Provider.CIN7_CORE:
    case Provider.REDO_API:
    case Provider.CUSTOM_RETURN_INTEGRATION:
    case Provider.MANUAL:
    case Provider.NETSUITE:
    case Provider.COMMERCE_CLOUD:
    case Provider.WAYFAIR:
    case Provider.SPS_COMMERCE:
    case Provider.BRIGHTPEARL:
    case Provider.WOOCOMMERCE:
    case Provider.LINNWORKS_TRACKSTAR:
    case Provider.LINNWORKS_DIRECT:
    case Provider.TEMU:
    case Provider.RITHUM:
    case Provider.FINALE:
    case Provider.APTOS:
      return undefined;
    default:
      assertNever(provider);
  }

  return undefined;
}
